// src/firebase.ts
//
// Eine Firebase-App für die ganze Seite. Sowohl das Newsletter-Formular in
// App.js als auch der PIPR-Chart lesen von hier — zwei `initializeApp`-Aufrufe
// mit derselben Config sind zwar erlaubt (die zweite App bekäme nur einen
// anderen Namen), erzeugen aber zwei Verbindungen und zwei Stellen, an denen
// die Projekt-ID gepflegt werden muss.
//
// Die Config ist kein Geheimnis: der API-Key identifiziert das Projekt, den
// Zugriff regeln die Security Rules. Sie darf im Bundle stehen.

import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";

declare global {
    interface Window {
        /** Nur in der Entwicklung gesetzt; siehe unten. */
        FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean | string;
    }
}

const firebaseConfig = {
    apiKey: "AIzaSyBBC2kREGsyH9OjpS-5OC4xUqJGwmXj0ow",
    authDomain: "website-newgate-li.firebaseapp.com",
    projectId: "website-newgate-li",
    storageBucket: "website-newgate-li.firebasestorage.app",
    messagingSenderId: "1027456557157",
    appId: "1:1027456557157:web:bb3e38dc8773d71742e68c",
    measurementId: "G-EV6BBYRGM8",
};

export const app = initializeApp(firebaseConfig);

// App Check bezeugt, dass Firestore-Aufrufe von der echten Seite kommen — das
// ist es, was Bots aus dem Anmeldeformular heraushält. Der reCAPTCHA-Key ist
// öffentlich und landet wie der apiKey oben im Bundle; er steht nur deshalb in
// einer Variable, damit der Build konfigurierbar bleibt, nicht weil er geheim
// wäre.
//
// Ohne gesetzten Key wird App Check übersprungen und alles verhält sich wie
// zuvor. Genau das erlaubt es, diesen Stand auszuliefern, bevor der Key
// existiert.
//
// Muss vor `getFirestore` stehen: wird der Dienst zuerst geholt, kann der erste
// Request ohne Token rausgehen und wird bei aktiver Erzwingung abgewiesen.
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

if (recaptchaSiteKey) {
    if (process.env.NODE_ENV !== "production") {
        // Gibt beim ersten Lauf ein Debug-Token in der Browserkonsole aus. Das
        // muss unter App Check > Apps > Debug-Token verwalten eingetragen
        // werden, sonst bleibt localhost gesperrt, sobald die Erzwingung läuft.
        window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true,
    });
}

export const db = getFirestore(app);